import React, { useContext } from 'react'
import { Pie } from 'react-chartjs-2'
import { ContentInner } from '../../../../../layout/Content'
import MonthlySalesInnerStyle from './css/MonthlySalesInnerStyle'
import { formatNumber } from '../../../../../utilities/utilities'
import { monthlySalesContext } from './MonthlySalesController'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'

function MonthlySales(props) {
  const monthlySalesController = useContext(monthlySalesContext)
  const monthlySalesReport = monthlySalesController.monthlySalesReport[0]
  const yearString = monthlySalesController.yearString[0]
  const { getClientDateTime, getClientTimezone, months } = monthlySalesController

  const getChartData = () => {
    const qs = monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales
    return ([qs.q1, qs.q2, qs.q3, qs.q4])
  }

  const dd = {
    labels: ['1st Quarter', '2nd Quarter', '3rd Quarter', '4th Quarter'],
    datasets: [
      {
        label: 'Quarterly Sales',
        data: (monthlySalesReport.length) ? getChartData() : [0, 0, 0, 0], //[10, 20, 30, 40],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(99, 12, 192, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(99, 12, 192, 1)',
        ],
        borderWidth: 1,
      },
    ]
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div className='ms-report-container printable'>
          <h3>Monthly Sales Report {yearString}</h3>
          <div>As of {new Date(getClientDateTime()).toLocaleString("en-us")} { getClientTimezone() }</div>
          <br/>
          <div className='ms-report-wrapper'>
            <div id='ms-left'>
              <table className='ms-report-table striped'>
                <thead>
                  <tr>
                    <th>Months</th>
                    <th style={{textAlign: 'center', backgroundColor: 'lightgreen'}}>Credits</th>
                    <th style={{textAlign: 'center', backgroundColor: '#4287F5'}}>Net Sales</th>
                    <th style={{textAlign: 'center'}}>Gross Sales</th>
                  </tr>
                </thead>
                {
                  monthlySalesReport.filter(msr => (msr.month)).map((msr, index) => (
                    <tbody key={index}>
                      <tr>
                        <td className='month'>{months[parseInt(msr.month - 1)]}</td>
                        <td style={{borderRight: 'solid 0.5px lightgreen'}}>P{formatNumber(parseFloat(msr.credit.total_gross_sales).toFixed(2))}</td>
                        <td style={{borderRight: 'solid 0.5px #4287F5'}}>P{formatNumber(parseFloat(msr.sales.total_net_sales).toFixed(2))}</td>
                        <td>P{formatNumber(parseFloat(msr.sales.total_gross_sales).toFixed(2))}</td>
                      </tr>
                    </tbody>
                  ))
                }
                <tbody>
                  <tr className='total'>
                    <td className='month'>Total</td>
                    <td style ={{backgroundColor: 'lightgreen'}}>
                    P
                    {
                      (monthlySalesReport.length)
                      ? formatNumber((monthlySalesReport.find(msr => msr.grand_total)).grand_total.credit.gross)
                      : 0.00
                    }
                    </td>
                    <td style={{backgroundColor: '#4287F5'}}>
                    P
                    {
                      (monthlySalesReport.length)
                      ? formatNumber((monthlySalesReport.find(msr => msr.grand_total)).grand_total.sales.net)
                      : 0.00
                    }
                    </td>
                    <td>
                    P
                    {
                      (monthlySalesReport.length)
                      ? formatNumber((monthlySalesReport.find(msr => msr.grand_total)).grand_total.sales.gross)
                      : 0.00
                    }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id='ms-right'>
              <div id='quarterly-sales-data'>
                <div style={{ fontWeight: 'bold' }}>Quarterly Gross Sales</div>
                <br />
                <div className='row'>
                  <div className='label'>1st Quarter</div> <div className='data'>
                  P
                  {
                    (monthlySalesReport.length)
                    ? formatNumber(monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales.q1)
                    : 0.00
                  }
                  </div>
                </div>

                <div className='row'>
                  <div className='label'>2nd Quarter</div> <div className='data'>
                  P
                  {
                    (monthlySalesReport.length)
                    ? formatNumber(monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales.q2)
                    : 0.00
                  }
                  </div>
                </div>
                <div className='row'>
                  <div className='label'>3rd Quarter</div> <div className='data'>
                  P
                  {
                    (monthlySalesReport.length)
                    ? formatNumber(monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales.q3)
                    : 0.00
                  }
                  </div>
                </div>
                <div className='row'>
                  <div className='label'>4th Quarter</div> <div className='data'>
                  P
                  {
                    (monthlySalesReport.length)
                    ? formatNumber(monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales.q4)
                    : 0.00
                  }
                  </div>
                </div>
                <div className='row total'>
                  <div className='label'>Total</div> <div className='data'>
                  P
                  {
                    (monthlySalesReport.length)
                    ? formatNumber(monthlySalesReport.find(msr => msr.quarterly_sales).quarterly_sales.total)
                    : 0.00
                  }
                  </div>
                </div>
              </div>
              <div className='ms-report-chart'>
                <Pie
                  data={dd}
                  width={150}
                  height={50}
                  options={{
                    maintainAspectRatio: true,
                    plugins: {
                      title: {
                        display: true,
                        text: 'Quarterly Sales'
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <MonthlySalesInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(MonthlySales)
